module.exports = __webpack_public_path__ + "assets/img/index-partner33.be1f5d45.jpg";